import Layout from "../../Internal/Layout.vue";
import UserConfigPage from "./UserConfig.vue";

const UserConfigRoutes = {
  component: Layout,
  children: [
    {
      path: "/userconfig",
      name: "UserConfig",
      component: UserConfigPage,
      meta: {
       },
    },
  ],
};

export default UserConfigRoutes;
